/**
 * Utility functions for working with contact IDs in text
 */

/**
 * Finds contact IDs in text and returns their positions and values
 * Contact IDs typically follow a pattern like A2ZY5TD0MN02NY - they start with 'A' followed by alphanumeric characters
 *
 * @param text The text to search for contact IDs
 * @returns Array of objects containing the start and end positions and the contact ID value
 */
export const findContactIds = (
  text: string
): { start: number; end: number; contactId: string }[] => {
  // Regular expression to match contact IDs (A followed by 9-15 alphanumeric characters)
  // The pattern ensures it starts with 'A' and is followed by 9-15 digits or uppercase letters
  const contactIdRegex = /\bA[0-9A-Z]{9,15}\b/g;
  const matches: { start: number; end: number; contactId: string }[] = [];

  let match;
  while ((match = contactIdRegex.exec(text)) !== null) {
    matches.push({
      start: match.index,
      end: match.index + match[0].length,
      contactId: match[0],
    });
  }

  return matches;
};
